import api from './clients';
import { Devolucion, DevolucionFormData, DevolucionStats } from '../types/devolucion';

export const devolucionesApi = {
  getAll: async (params?: any): Promise<Devolucion[]> => {
    const response = await api.get('/devoluciones', { params });
    return response.data?.data || [];
  },

  getById: async (id: number): Promise<Devolucion> => {
    const response = await api.get(`/devoluciones/${id}`);
    return response.data?.data;
  },

  create: async (data: DevolucionFormData): Promise<Devolucion> => {
    const response = await api.post('/devoluciones', data);
    return response.data?.data;
  },

  update: async (id: number, data: Partial<DevolucionFormData>): Promise<Devolucion> => {
    const response = await api.put(`/devoluciones/${id}`, data);
    return response.data?.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/devoluciones/${id}`);
  },

  getStats: async (): Promise<DevolucionStats> => {
    const response = await api.get('/devoluciones/estadisticas');
    return response.data?.data;
  },
};